import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {marginHistoryOrderData$, spotHistoryOrderData$} from './orders-history';
import type {MarginHistoryOrderData} from '@/types';

export interface UMarinOrderHistory {
  type: 'margin-orders-history';
  data: MarginHistoryOrderData;
}

export interface UUtaSpotOrdersHistory {
  type: 'uta-spot-orders-history';
  data: MarginHistoryOrderData;
}

export function subscriberOrdersHistory() {
  marginHistoryOrderData$
    .pipe(
      map(
        (orderData: MarginHistoryOrderData): UMarinOrderHistory => ({
          type: 'margin-orders-history',
          data: orderData,
        })
      )
    )
    .subscribe((msg) => toUiMsg$.next(msg));

  spotHistoryOrderData$
    .pipe(
      map(
        (orderData: MarginHistoryOrderData): UUtaSpotOrdersHistory => ({
          type: 'uta-spot-orders-history',
          data: orderData,
        })
      )
    )
    .subscribe((msg) => toUiMsg$.next(msg));
}
